import { parse } from 'graphql';

import { sessionSchema } from './schema';

export const onCreateSession = parse(`
  subscription onCreateSession($filter: SessionFilterInput) {
    onCreateSession(filter: $filter) {
      ${sessionSchema}
    }
  }
`);

export const onUpdateSession = parse(`
  subscription onUpdateSession($filter: SessionFilterInput) {
    onUpdateSession(filter: $filter) {
      ${sessionSchema}
    }
  }
`);

export const onDeleteSession = parse(`
  subscription onDeleteSession($filter: SessionFilterInput) {
    onDeleteSession(filter: $filter) {
      ${sessionSchema}
    }
  }
`);

export const onAddContractToSession = `
  subscription onAddContractToSession {
    onAddContractToSession {
      session {
        ${sessionSchema}
      }
    }
  }
`;
export const onRemoveContractsFromSession = `
  subscription onRemoveHoranetContractsFromSession {
    onRemoveHoranetContractsFromSession {
      session
      contracts
    }
  }
`;
